<template>
  <v-container fluid>
    <app-toolbar 
      @datesUpdate="datesUpdate"
    />
    <app-filters
      :cats="cats"
      :filters="filters"
      :criteriaFilters="criteriaFilters"
      @filtersUpdate="filtersUpdate"

    />
    <app-charts
      :reportingData="reportingData.perDay"
      :loading="loading"
    />
    <app-per-criteria 
      :reportingData="reportingData.perCriteria"
      :loading="loading"
      @perCriteriaUpdate="perCriteriaUpdate"
      :cats="cats"
    />
  </v-container>
</template>

<script>
  import axios from 'axios'
  import Toolbar from './Toolbar.vue'
  import Filters from './filters/index.vue'
  import Charts from './charts/index.vue'
  import PerCriteria from './perCriterias/index.vue'

  export default {
    components: {
      AppFilters: Filters,
      AppToolbar : Toolbar,
      AppCharts : Charts,
      AppPerCriteria: PerCriteria,
    },
    data(){
      return {
        loading: false,
        dates : [],
        filters : {},
        criteriaFilters : {}, //created to manage clicks on row,deep watcher does not work
        reportingData : {
          perCriteria : {
            bidder: [],
            custadunit: [],
            device: [],
            invtype: [],
            inventory: []
          }
        },
        dataSync : false
      }
    },
    created(){
      this.cats.forEach((cat) => {
        this.filters[cat] = []
      })

    },
    methods: {
      datesUpdate(dates){
        this.dates = dates
        if(this.dataSync) this.getDataFromApi();
        this.dataSync = true 

      },
      filtersUpdate(foo){
        this.filters = {}
        this.filters = foo
        if(this.dataSync) this.getDataFromApi();
        this.dataSync = true 
      },
      perCriteriaUpdate(foo){
        this.criteriaFilters[foo.category] = foo.id
        this.filters[foo.category].push(foo.id)
        if(this.dataSync) this.getDataFromApi();
        this.dataSync = true
      },
      async getDataFromApi() {
        this.loading = true
        const request = {
          type : 'reporting/reporting',
          action : "getData",
          data: {
            filters: this.filters,
            dates : this.dates
          }
        };
        try {
          const accessToken = await this.$auth.getAccessToken()
          const response = await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          this.reportingData = response.data
          this.loading = false
        } catch (e) {
          this.$router.push("/login")
          console.error(e)
          this.loading = false  
        }

      },
    },
    computed: {
      cats(){
        return Object.keys(this.reportingData.perCriteria)
      }
    }
  } 
</script>